export enum LanguageType {
    EN = 'en',
    JA = 'ja'
}

export const Language_Local_Storage = 'translocoLang'